import { Button, Col, Form, InputNumber, Modal, Row, Upload } from 'antd';
import styled from 'styled-components';
import { UploadOutlined } from '@ant-design/icons';

const StyledDiv = styled.div``;

interface BidProposalCreateModalProps {
  visible: boolean;
  uploadProps: any;
  onFinish: (data: any) => void;
  onCancel: () => void;
}

function BidProposalCreateModal({
  visible,
  uploadProps,
  onFinish,
  onCancel,
}: BidProposalCreateModalProps) {
  const [form] = Form.useForm();
  const normFile = (e: any) => {
    let fileList = e.fileList;
    if (Array.isArray(e)) {
      return e;
    }
    return e && fileList;
  };

  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="견적가 제출하기"
        okText="확인"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              onFinish(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Row justify="center" style={{ marginBottom: '10px' }}>
          <Col span={20}>
            <Form
              form={form}
              layout="vertical"
              name="control-hooks"
              onFinish={onFinish}
              initialValues={{}}
            >
              <Form.Item name="amount" label="견적가">
                <InputNumber
                  prefix="₩"
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  parser={(value) => value!.replace(/(,*)/g, '')}
                  style={{ width: '80%' }}
                />
              </Form.Item>

              <Form.Item
                name="file"
                label="첨부 파일"
                valuePropName="fileList"
                getValueFromEvent={normFile}
              >
                <Upload {...uploadProps}>
                  <Button icon={<UploadOutlined rev={undefined} />}>
                    파일 올리기
                  </Button>
                </Upload>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Modal>
    </StyledDiv>
  );
}

export default BidProposalCreateModal;
